
ko.bindingHandlers.slashedName = {
    update: function (elem, valueAccessor, allBindings) {
        const encodeHtml = (html) => {
            return document.createElement('a').appendChild(
                document.createTextNode(html)).parentNode.innerHTML;
        }

        const color = allBindings().slashedNameColor ?? '#bdbdbd';

        const value = ko.utils.unwrapObservable(valueAccessor());

        elem.innerHTML = value.split('/').map(i => encodeHtml(i)).join(`<span style="color:${color};"> / </span>`)

         
    }
}
ko.virtualElements.allowedBindings.animate = true;
